export default "__VITE_ASSET__DHIG3nbW__"